import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import CompanyPanel from "@/pages/company/CompanyPanel";
import InstructorPanel from "@/pages/instructor/InstructorPanel";
import AdminPanel from "@/pages/admin/AdminPanel";
import { BookOpen, Certificate, PlayCircle, ArrowRight, GraduationCap } from "@phosphor-icons/react";

function StudentOverview() {
  const { user } = useAuth();
  const [enrs, setEnrs] = useState([]);
  const [certs, setCerts] = useState([]);
  useEffect(() => {
    api.get("/enrollments").then((r) => setEnrs(r.data)).catch(() => {});
    api.get("/certificates").then((r) => setCerts(r.data)).catch(() => {});
  }, []);
  const inProgress = enrs.filter((e) => !e.passed);
  const stats = [
    { label: "Cursos activos", value: inProgress.length, icon: BookOpen },
    { label: "Cursos aprobados", value: enrs.filter((e) => e.passed).length, icon: GraduationCap },
    { label: "Certificados", value: certs.length, icon: Certificate },
  ];
  return (
    <div>
      <p className="text-xs uppercase tracking-overline text-primary mb-1 font-mono">Panel del alumno</p>
      <h1 className="font-display text-3xl font-800 tracking-tight mb-1">Hola, {user.name.split(" ")[0]} 👋</h1>
      <p className="text-muted-foreground mb-8">Continúa donde lo dejaste.</p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
        {stats.map((s) => {
          const Icon = s.icon;
          return (
            <div key={s.label} className="bg-white border border-border rounded-lg p-5 flex items-center gap-4">
              <div className="w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center">
                <Icon size={24} className="text-primary" weight="duotone" />
              </div>
              <div>
                <div className="font-display text-2xl font-800">{s.value}</div>
                <div className="text-sm text-muted-foreground">{s.label}</div>
              </div>
            </div>
          );
        })}
      </div>

      <h2 className="font-display text-xl font-800 tracking-tight mb-4">Continuar aprendiendo</h2>
      {inProgress.length === 0 ? (
        <div className="bg-white border border-border rounded-lg p-10 text-center">
          <p className="text-muted-foreground mb-4">No tienes cursos en progreso.</p>
          <Link to="/catalogo"><Button className="bg-primary text-white hover:bg-blue-600">Explorar catálogo</Button></Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-4">
          {inProgress.map((e) => (
            <Link key={e.id} to={`/dashboard/curso/${e.course_id}`} data-testid={`continue-${e.course_id}`}
              className="bg-white border border-border rounded-lg overflow-hidden flex transition-transform hover:-translate-y-[2px] hover:shadow-sm">
              <img src={e.course?.image_url} alt="" className="w-28 object-cover shrink-0" />
              <div className="p-4 flex-1 min-w-0">
                <h3 className="font-semibold text-sm line-clamp-1">{e.course_title}</h3>
                <Progress value={e.progress_pct} className="h-2 mt-3" />
                <div className="flex items-center justify-between mt-2">
                  <span className="text-xs text-muted-foreground">{e.progress_pct}% completado</span>
                  <PlayCircle size={20} className="text-primary" weight="fill" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default function DashboardHome() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "company") return <CompanyPanel />;
  if (user.role === "instructor") return <InstructorPanel />;
  if (user.role === "admin") return <AdminPanel />;
  return <StudentOverview />;
}
